import PropTypes from "prop-types"

export const COLUMN = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  formatter: PropTypes.func,
  render: PropTypes.func,
})

export const COLUMNS = PropTypes.arrayOf(COLUMN)
